import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class AdminuserService extends GenericService {
  constructor() {
    super('/users', axiosInstance);
  }
}

export default new AdminuserService(); 